import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Photo = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.562 17.386c-.788-3.228 2.07-6.058 5.284-5.289h.002a4.345 4.345 0 0 1 3.156 3.155c.787 3.228-2.07 6.058-5.284 5.29l-.005-.002a4.366 4.366 0 0 1-3.153-3.154Zm1.78-.435a2.532 2.532 0 0 0 1.807 1.808c1.894.451 3.532-1.191 3.074-3.071a2.512 2.512 0 0 0-1.805-1.808c-1.895-.452-3.534 1.19-3.075 3.071Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.236A3.225 3.225 0 0 1 3.227 6.01h37.546A3.225 3.225 0 0 1 44 9.236v26.352c0 1.79-1.45 3.238-3.239 3.238H3.227A3.225 3.225 0 0 1 0 35.6V9.236Zm25.471 20.435 7.125-7.125a.917.917 0 0 1 1.297 0l8.274 8.274V9.236c0-.773-.626-1.393-1.394-1.393H3.227c-.774 0-1.394.625-1.394 1.393V27.63L11.99 17.474a.917.917 0 0 1 1.296 0l12.185 12.197Zm-.648 1.944L12.638 19.431 1.833 30.235V35.6c0 .774.626 1.393 1.394 1.393H40.76c.777 0 1.406-.628 1.406-1.406v-2.174l-8.923-8.922-7.125 7.125-.01.01a.917.917 0 0 1-1.286-.01Z"
  }));
});
Photo.displayName = 'Photo';
Photo.defaultProps = {
  'aria-label': 'Photo'
};
export default Photo;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Photo.js
// module id = 3243
// module chunks = 11